<template>
  <v-app>
    <app-header />

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import AppHeader from '../../components/main/Header';
import AppFooter from '../../components/main/Footer';

export default {
  data: () => ({
    valid: true
  }),
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style lang="scss"></style>
